
import { normalizeValidationErrors } from "../../helpers/normalizers";

export const getApiErrorText = (error: ApiError): string => {
    const rawErrors = error.details?.errors;

    if (Array.isArray(rawErrors)) {
        // return `${rawErrors[0] || error.message || ""}`;
        const errorText = rawErrors.filter((item): item is string => typeof item === "string").join(", ");
        return errorText || error.message || "";
    }

    // if (rawErrors && typeof rawErrors === "object" && "error" in rawErrors) {
    //     return `${rawErrors.error || error.message || ""}`;
    // }
    if (rawErrors && typeof rawErrors === "object") {
        const errorText = rawErrors.error;
        if (typeof errorText === "string") {
            return errorText;
        }

        const normalizedErrors = normalizeValidationErrors(rawErrors);
        if (normalizedErrors.length) {
            return normalizedErrors.map(({message}) => message).join(", ");
        }
    }

    return error.message || "";
};
